//Language  Native Name   Code
//Czech       Čeština     cs
//Dutch       Nederlands  nl
//English     English     en
//French      Français    fr
//German      Deutsch     de
//Italian     Italiano    it
//Polish      Polski      pl
//Portuguese  Português   pt
//Spanish     Español     es
 
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
 
import commonEnglish from "../../locales/english/message_lang.json";
import commonFrench from "../../locales/french/message_lang.json";
import commonCzech from "../../locales/czech/message_lang.json";
import commonSpanish from "../../locales/spanish/message_lang.json";
import commonItalian from "../../locales/italian/message_lang.json";
import commonGerman from "../../locales/german/message_lang.json";
import commonDutch from "../../locales/dutch/message_lang.json";
import commonPolish from "../../locales/polish/message_lang.json";
import commonPortuguese from "../../locales/portuguese/message_lang.json";
 
 
/* ---------- Get language from session ---------- */

const normalizeLanguageCode = (lang) => {
  const normalized = String(lang || "").toLowerCase();
  const languageMap = {
    en: "en",
    fr: "fr",
    es: "es",
    de: "de",
    nl: "nl",
    it: "it",
    cz: "cs",
    cs: "cs",
    pl: "pl",
    pt: "pt"
  };

  return languageMap[normalized] || "";
};

const getLanguageFromUrl = () => {
  if (typeof window === "undefined") return "";

  const params = new URLSearchParams(window.location.search);
  return normalizeLanguageCode(params.get("lang"));
};
 
const getDefaultLanguage = () => {
  const languageFromUrl = getLanguageFromUrl();
  if (languageFromUrl) return languageFromUrl;

  const savedLang = sessionStorage.getItem("language");
  //console.log("Saved language in session:", savedLang);
  if (!savedLang) return "en";
 
  try {
    const parsed = JSON.parse(savedLang);
    return normalizeLanguageCode(parsed?.code) || "en";
  } catch {
    return "en";
  }
};
 
const defaultLang = getDefaultLanguage();
//console.log("commonDutch:", commonDutch);
i18n.use(initReactI18next).init({
  //debug: process.env.NODE_ENV !== "test",
  load: "languageOnly",
  resources: {
    en: { common: commonEnglish },
    fr: { common: commonFrench },
    es: { common: commonSpanish },
    de: { common: commonGerman },
    nl: { common: commonDutch },
    it: { common: commonItalian },
    cs: { common: commonCzech },
    pl: { common: commonPolish },
    pt: { common: commonPortuguese }

  },
 
  lng: defaultLang, // load language from session
  fallbackLng: "en",
 
  ns: ["common"],
  defaultNS: "common",
  interpolation: {
    escapeValue: false
  }
});
export default i18n;
